// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"968cdc66","661":"9efdbef2","720":"04069186"}[chunkId] + ".chunk.js";
};